import { IconWrapper, Stack } from '@garner-health/components-common';
import React, { ReactNode } from 'react';

export const IconLabel = ({ icon, body }: { icon: ReactNode; body: ReactNode }) => (
  <Stack alignItems="center" direction="row">
    <IconWrapper color="common.muted">{icon}</IconWrapper>
    <Stack.Group>{body}</Stack.Group>
  </Stack>
);
